const anchorMenu = document.getElementById('anchor-menu');
const navToggleOpen = document.getElementById('navigation-open');
const navToggleClose = document.getElementById('navigation-close');

if (window.innerWidth > 900) {

    window.addEventListener('resize', function () {

        if (window.scrollY >= 40) {
            if (anchorMenu) {
                anchorMenu.classList.add('anchor-menu--sticky');
            }

            if (navToggleOpen) {
                navToggleOpen.classList.add('nav-toggle--sticky');
            }

            if (navToggleClose) {
                navToggleClose.classList.add('nav-toggle--sticky');
            }
        } else {
            if (anchorMenu) {
                anchorMenu.classList.remove('anchor-menu--sticky');
            }

            if (navToggleOpen) {
                navToggleOpen.classList.remove('nav-toggle--sticky');
            }

            if (navToggleClose) {
                navToggleClose.classList.remove('nav-toggle--sticky');
            }
        }

    });

    window.addEventListener('scroll', function () {

        if (window.scrollY >= 40) {
            if (anchorMenu) {
                anchorMenu.classList.add('anchor-menu--sticky');
            }

            if (navToggleOpen) {
                navToggleOpen.classList.add('nav-toggle--sticky');
            }

            if (navToggleClose) {
                navToggleClose.classList.add('nav-toggle--sticky');
            }
        } else {
            if (anchorMenu) {
                anchorMenu.classList.remove('anchor-menu--sticky');
            }

            if (navToggleOpen) {
                navToggleOpen.classList.remove('nav-toggle--sticky');
            }

            if (navToggleClose) {
                navToggleClose.classList.remove('nav-toggle--sticky');
            }
        }

    });

}

